// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__15BZC","itemTitle":"ClientEmergencyInfo_itemTitle__36DaR","itemText":"ClientEmergencyInfo_itemText__2dhL-"};